import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.exchangePlaidSuccess"],
  payload => payload
);
